import { render, staticRenderFns } from "./CommentsAction.vue?vue&type=template&id=78a1c7cc&scoped=true"
import script from "./CommentsAction.vue?vue&type=script&lang=js"
export * from "./CommentsAction.vue?vue&type=script&lang=js"
import style0 from "./CommentsAction.vue?vue&type=style&index=0&id=78a1c7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a1c7cc",
  null
  
)

export default component.exports